<template>
  <div>
    <sales-performance-filters @downloadSalesPerformanceData="downloadSalesPerformanceData" :loading="loadingData"/>
    <div class="card" v-if="hasData">
      <div class="card-header bg-transparent border-bottom">
        <div v-if="loadingData">
            <div class="m-4 text-center text-primary">Loading ...</div>
        </div>
        <div v-else>
          <div v-for="(r, key) in tData" :key="key">
            <span v-if="r.data.length > 0">
              <div class="mt-3">
              <h3 class="mb-3"><strong><span class="text-primary">{{r.record}}</span> </strong></h3>
              <h5 class="mb-3"><strong>Period: </strong> {{r.date_range}}</h5>
              <h5 class="mb-3"><strong>Total Gross: </strong> Ksh {{r.total_gross | formatNumber}}</h5>
              <h5 class="mb-3"><strong>Total Net: </strong> Ksh {{r.total_net | formatNumber}}</h5>
            </div>
              <order-performance-table :table-data="r.data" @setOrders="setOrders"/>
            </span>
          </div>
          <individual-sales-performance :sales-data-options="salesDataOptions" :sales-data-series="salesDataSeries"/>
        </div>
        </div>
    </div>
    <div v-else class="card">
      <div class="card-header bg-transparent border-bottom">
        <b-tabs
            nav-class="nav-tabs-custom card-header-tabs ms-auto"
            nav-wrapper-class="nav-item"
            align="right"
        >
          <b-tab title="Day">
          <span v-if="dailyLoading">
            <span class="m-4 text-center text-primary">Loading ...</span>
          </span>
          <div v-else>
            <simple-order-performance-table :table-data="dailyData"/>
            <individual-sales-performance  :sales-data-options="dailySalesDataOptions" :sales-data-series="dailySalesDataSeries"/>
          </div>

          </b-tab>
          <b-tab title="Week" active>
          <span v-if="weeklyLoading">
            <span class="m-4 text-center text-primary">Loading ...</span>
          </span>
          <div v-else>
            <simple-order-performance-table :table-data="weeklyData"/>
            <individual-sales-performance :sales-data-options="weeklySalesDataOptions" :sales-data-series="weeklySalesDataSeries"/>
          </div>

          </b-tab>
          <b-tab title="Month">
          <span v-if="monthlyLoading">
            <span class="m-4 text-center text-primary">Loading ...</span>
          </span>
          <div v-else>
            <simple-order-performance-table :table-data="monthlyData"/>
            <individual-sales-performance :sales-data-options="monthlySalesDataOptions" :sales-data-series="monthlySalesDataSeries"/>
          </div>

          </b-tab>
          <b-tab title="Year">
          <span v-if="yearlyLoading">
            <span class="m-4 text-center text-primary">Loading ...</span>
          </span>
          <div v-else>
            <simple-order-performance-table :table-data="yearlyData"/>
            <individual-sales-performance :sales-data-options="yearlySalesDataOptions" :sales-data-series="yearlySalesDataSeries"/>
          </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <b-modal
        id="orders-performance-table"
        centered
        hide-footer
        hide-header
        size="xl"
        title-class="font-18">
      <table class="table">
        <thead class="table-light">
        <tr>
          <th>Customer</th>
          <th>Invoice ID</th>
          <th>Delivery Date</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody v-for="(item, index) in selectedOrders" :key="index">
        <tr>
          <td>{{item.customer.name}}</td>
          <td>{{item.invoice_id}}</td>
          <td>{{item.delivery_date}}</td>
          <td><order-status-component :order_status="item.status"/></td>
          <td>
            <b-button variant="info" size="sm" class="py-1 text-white" @click="viewOrderInvoice(item.public_id)">
              View Invoice
            </b-button>
          </td>
        </tr>
        </tbody>
      </table>
    </b-modal>
  </div>

</template>

<script>
import {mapActions} from "vuex";
import IndividualSalesPerformance from "@/components/dashboard/IndividualSalesPerformance";
import SalesPerformanceFilters from "@/components/dashboard/SalesPerformanceFilters";
import OrderPerformanceTable from "@/components/dashboard/OrderPerformanceTable";
import {routeItems} from "@/router/endpoints";
import OrderStatusComponent from "@/components/orders/order-status-component";
import SimpleOrderPerformanceTable from "@/components/dashboard/SimpleOrderPerformanceTable";

export default {
  name: "SalesPerformance",
  components: {
    SimpleOrderPerformanceTable,
    OrderStatusComponent, OrderPerformanceTable, SalesPerformanceFilters, IndividualSalesPerformance},
  data(){
    return {
      selectedOrders: [],

      hasData: false,
      loadingData: false,
      orderDataSeries: [],
      salesDataSeries: [],
      tData: [],
      orderDataOptions: {
        chart: {
          height: 350,
          type: "line",
        },
        colors: ["#ff6600"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 4,
        },
        title: {
          text: 'Order Data Performance'
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: 'Orders'
          }
        },
        markers: {
          size: 1,
          strokeWidth: 1,
          hover: {
            size: 4,
            sizeOffset: 2,
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
        },
      },
      salesDataOptions: {
        chart: {
          height: 350,
          type: "bar",
        },
        colors: ["#ff6600", "#0d659d"],
        dataLabels: {
          enabled: false,
        },
        title: {
          text: 'Net Total and Net Total (Previous Year) Performance'
        },
        xaxis: {
          categories: [],
        },
      },

      dailyLoading: true,
      dailyOrderDataSeries: [],
      dailySalesDataSeries: [],
      dailyOrderDataOptions: {
        chart: {
          height: 350,
          type: "line",
        },
        colors: ["#ff6600"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 4,
        },
        title: {
          text: 'Order Data Performance'
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: 'Orders'
          }
        },
        markers: {
          size: 1,
          strokeWidth: 1,
          hover: {
            size: 4,
            sizeOffset: 2,
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
        },
      },
      dailySalesDataOptions: {
        chart: {
          height: 350,
          type: "bar",
        },
        colors: ["#ff6600", "#0d659d"],
        dataLabels: {
          enabled: false,
        },
        title: {
          text: 'Gross and Net Sales Performance'
        },
        xaxis: {
          categories: [],
        },
      },
      dailyData: {},

      weeklyLoading: true,
      weeklyOrderDataSeries: [],
      weeklySalesDataSeries: [],
      weeklyOrderDataOptions: {
        chart: {
          height: 350,
          type: "line",
        },
        colors: ["#ff6600"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 4,
        },
        title: {
          text: 'Order Data Performance'
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: 'Orders'
          }
        },
        markers: {
          size: 1,
          strokeWidth: 1,
          hover: {
            size: 4,
            sizeOffset: 2,
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
        },
      },
      weeklySalesDataOptions: {
        chart: {
          height: 350,
          type: "bar",
        },
        colors: ["#ff6600", "#0d659d"],
        dataLabels: {
          enabled: false,
        },
        title: {
          text: 'Gross and Net Sales Performance'
        },
        xaxis: {
          categories: [],
        },
      },
      weeklyData: {},

      monthlyLoading: true,
      monthlyOrderDataSeries: [],
      monthlySalesDataSeries: [],
      monthlyOrderDataOptions: {
        chart: {
          height: 350,
          type: "line",
        },
        colors: ["#ff6600"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 4,
        },
        title: {
          text: 'Order Data Performance'
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: 'Orders'
          }
        },
        markers: {
          size: 1,
          strokeWidth: 1,
          hover: {
            size: 4,
            sizeOffset: 2,
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
        },
      },
      monthlySalesDataOptions: {
        chart: {
          height: 350,
          type: "bar",
        },
        colors: ["#ff6600", "#0d659d"],
        dataLabels: {
          enabled: false,
        },
        title: {
          text: 'Gross and Net Sales Performance'
        },
        xaxis: {
          categories: [],
        },
      },
      monthlyData: {},

      yearlyLoading: true,
      yearlyOrderDataSeries: [],
      yearlySalesDataSeries: [],
      yearlyOrderDataOptions: {
        chart: {
          height: 350,
          type: "line",
        },
        colors: ["#ff6600"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 4,
        },
        title: {
          text: 'Order Data Performance'
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: 'Orders'
          }
        },
        markers: {
          size: 1,
          strokeWidth: 1,
          hover: {
            size: 4,
            sizeOffset: 2,
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
        },
      },
      yearlySalesDataOptions: {
        chart: {
          height: 350,
          type: "bar",
        },
        colors: ["#ff6600", "#0d659d"],
        dataLabels: {
          enabled: false,
        },
        title: {
          text: 'Gross and Net Sales Performance'
        },
        xaxis: {
          categories: [],
        },
      },
      yearlyData: {},
    }
  },
  mounted() {
    this.salesPerformanceData()
  },
  methods: {
    ... mapActions({
      generateSalesPerformanceData: 'http/generateSalesPerformanceData',
      generateFilteredSalesReport: 'http/generateFilteredSalesReport'
    }),
    async salesPerformanceData(){
      await this.dailySalesPerformance()
      await this.weeklySalesPerformance()
      await this.monthlySalesPerformance()
      await this.yearlySalesPerformance()

    },
    async dailySalesPerformance(){
      this.dailyLoading = true

      const daily = await this.generateSalesPerformanceData('daily')
      if(daily){
        const  dataSeries = this.dataSeries(daily)
        this.dailySalesDataSeries = dataSeries.salesSeries
        this.dailyOrderDataSeries = dataSeries.orderSeries
        this.dailyOrderDataOptions.xaxis.categories = daily.apex.categories
        this.dailySalesDataOptions.xaxis.categories = daily.apex.categories
        this.dailyData = this.tableData(daily)

        this.dailyLoading = false
      }
    },
    async weeklySalesPerformance(){
      this.weeklyLoading = true

      const weekly = await this.generateSalesPerformanceData('weekly')
      if(weekly){
        const  dataSeries = this.dataSeries(weekly)
        this.weeklySalesDataSeries = dataSeries.salesSeries
        this.weeklyOrderDataSeries = dataSeries.orderSeries
        this.weeklyOrderDataOptions.xaxis.categories = weekly.apex.categories
        this.weeklySalesDataOptions.xaxis.categories = weekly.apex.categories
        this.weeklyData = this.tableData(weekly)

        this.weeklyLoading = false
      }
    },
    async monthlySalesPerformance(){
      this.monthlyLoading = true

      const monthly = await this.generateSalesPerformanceData('monthly')
      if(monthly){
        const  dataSeries = this.dataSeries(monthly)
        this.monthlySalesDataSeries = dataSeries.salesSeries
        this.monthlyOrderDataSeries = dataSeries.orderSeries
        this.monthlyOrderDataOptions.xaxis.categories = monthly.apex.categories
        this.monthlySalesDataOptions.xaxis.categories = monthly.apex.categories
        this.monthlyData = this.tableData(monthly)

        this.monthlyLoading = false
      }
    },
    async yearlySalesPerformance(){
      this.yearlyLoading = true

      const yearly = await this.generateSalesPerformanceData('yearly')
      if(yearly){
        const  dataSeries = this.dataSeries(yearly)
        this.yearlySalesDataSeries = dataSeries.salesSeries
        this.yearlyOrderDataSeries = dataSeries.orderSeries
        this.yearlyOrderDataOptions.xaxis.categories = yearly.apex.categories
        this.yearlySalesDataOptions.xaxis.categories = yearly.apex.categories
        this.yearlyData = this.tableData(yearly)

        this.yearlyLoading = false
      }
    },
    dataSeries(data){
      const salesSeries = []
      const orderSeries = []

      data.apex.data.forEach(graph => {
        if(graph.name === "Gross Sales" || graph.name === "Net Sales"){
          salesSeries.push(graph)
        }else {
          orderSeries.push(graph)
        }
      })
      return {
        salesSeries,
        orderSeries
      }
    },
    tableData(data){
      const grossSeries = []
      const netSeries = []
      const orderSeries = []

      data.apex.data.forEach(graph => {
        if(graph.name === "Gross Sales"){
          grossSeries.push(graph)
        }else if(graph.name === "Net Sales"){
          netSeries.push(graph)
        } else {
          orderSeries.push(graph)
        }
      })

      return data.apex.categories.map((itm, i) => {
        return { "period": itm, "period_orders": orderSeries[0].data[i], "period_gross_total": grossSeries[0].data[i], "period_net_total": netSeries[0].data[i]}
      })



    },
    async downloadSalesPerformanceData(data){
      this.hasData = false
      this.loadingData = true

      await this.generateFilteredSalesReport(data).then(response => {
        const  dataSeries = this.filteredDataSeries(response)
        this.salesDataSeries = dataSeries.netSeries
        this.orderDataSeries = dataSeries.other
        this.orderDataOptions.xaxis.categories = response.apex.categories
        this.salesDataOptions.xaxis.categories = response.apex.categories
        this.tData = response.data
        this.hasData = true
        this.loadingData = false
      }).catch(()=>{
        this.loadingData = false
      }).finally(()=>{
        this.loadingData = false
      })
    },
    filteredDataSeries(data){
      const netSeries = []
      const other = []

      data.apex.data.forEach(graph => {
        if(graph.name === "Net Sales (Previous Year)" || graph.name === "Net Sales"){
          netSeries.push(graph)
        }else{
          other.push(graph)
        }
      })
      return {
        netSeries,
        other
      }
    },
    setOrders(orders){
      this.selectedOrders = orders
    },
    viewOrderInvoice(public_id){
      const routeData = this.$router.resolve({path: routeItems.customer_order_invoice_route+'/'+public_id, query: {keyword: this.searchKeyword}})
      window.open(routeData.href, '_blank');
    },
  }
}
</script>

<style scoped>

</style>
